import { Object3D } from "three";
import EditorNodeMixin from "./EditorNodeMixin";

export default class PersistableNode extends EditorNodeMixin(Object3D) {
  static componentName = "persistable";

  static nodeName = "Persistable";

  static disableTransform = true;

  static disableVisible = true;

  constructor(editor) {
    super(editor);

    this.networkable = false;
  }

  static async deserialize(editor, json) {
    const node = await super.deserialize(editor, json);

    return node;
  }

  copy(source, recursive = true) {
    super.copy(source, recursive);
    return this;
  }

  serialize() {
    return super.serialize({
      [PersistableNode.componentName]: {
        networkable: this.networkable
      }
    });
  }

  prepareForExport() {
    super.prepareForExport();
    this.addGLTFComponent(PersistableNode.componentName, {
      networkable: this.networkable,
      uuid: this.uuid
    });
  }

  onAdd() {
    super.onAdd();
    this.type = PersistableNode.nodeName;
  }
}
